import React from "react";
import CustomPagination from "../CustomPagination/CustomPagination";
import { DISPLAY_MODE } from "../../../components/app/consts";
import { TableView, GridView } from "./Partials";
import EmptyState from "./Partials/EmptyState/EmptyState";
import { MainContainer, ContentContainer } from "./SmartTableContainer.styled";
import ModeSwitcher from "./Partials/ModeSwitcher/ModeSwitcher";
import styled from "styled-components";

const StyledContentContainer = styled(ContentContainer)`
  .MuiTableRow-root {
    position: relative;
  }

  .MuiTableCell-root {
    transition: background-color 0.2s ease;
  }

  thead {
    position: sticky;
    top: 0;
    z-index: 2;
  }
`;

const SmartTableContainer = ({
  columns,
  data,
  rowCount,
  pagination,
  setPagination,
  sorting,
  setSorting,
  isLoading,
  onRowClick,
  onItemClick,
  itemToRender,
  mode = DISPLAY_MODE.TABLE,
  enableRowSelection = true,
  showEmptyData,
  columnsGrid = 3,
  rowSelection = {},
  onRowSelectionChange,
  onRowMouseEnter,
  onRowMouseLeave,
  state,
}) => {
  const safeState = {
    ...(state || {}),
    rowSelection: (state && state.rowSelection) || rowSelection || {},
  };

  const tableForPagination = {
    getState: () => ({
      pagination,
    }),
    setPageIndex: (index) =>
      setPagination((prev) => ({ ...prev, pageIndex: index })),
    setPageSize: (size) => setPagination({ pageIndex: 0, pageSize: size }),
    getCanPreviousPage: () => pagination.pageIndex > 0,
    getCanNextPage: () => pagination.pageIndex < rowCount - 1,
    previousPage: () =>
      setPagination((prev) => ({
        ...prev,
        pageIndex: Math.max(prev.pageIndex - 1, 0),
      })),
    nextPage: () =>
      setPagination((prev) => ({
        ...prev,
        pageIndex: Math.min(prev.pageIndex + 1, rowCount - 1),
      })),
    options: {
      rowCount,
    },
  };

  const renderContent = () => {
    if (isLoading) {
      return (
        <TableView
          columns={columns}
          data={[]}
          rowCount={0}
          pagination={pagination}
          setPagination={setPagination}
          sorting={sorting}
          setSorting={setSorting}
          isLoading={true}
          onRowClick={onRowClick}
          enableRowSelection={enableRowSelection}
          rowSelection={safeState.rowSelection}
          onRowSelectionChange={onRowSelectionChange}
          onRowMouseEnter={onRowMouseEnter}
          onRowMouseLeave={onRowMouseLeave}
        />
      );
    }

    if (!data || data.length === 0) {
      return showEmptyData || (
        <EmptyState
          title="There are no records"
          description="Please add a record"
        />
      );
    }

    return (
      <>
        {mode === DISPLAY_MODE.TABLE && (
          <TableView
            columns={columns}
            data={data}
            rowCount={rowCount}
            pagination={pagination}
            setPagination={setPagination}
            sorting={sorting}
            setSorting={setSorting}
            isLoading={isLoading}
            onRowClick={onRowClick}
            enableRowSelection={enableRowSelection}
            rowSelection={safeState.rowSelection}
            onRowSelectionChange={onRowSelectionChange}
            onRowMouseEnter={onRowMouseEnter}
            onRowMouseLeave={onRowMouseLeave}
          />
        )}

        {mode === DISPLAY_MODE.GRID && (
          <GridView
            data={data}
            onItemClick={onItemClick}
            itemToRender={itemToRender}
            columns={columnsGrid}
          />
        )}
      </>
    );
  };

  return (
    <MainContainer>
      <StyledContentContainer>
        {renderContent()}
      </StyledContentContainer>

      {!isLoading && data && data.length > 0 && (
        <CustomPagination table={tableForPagination} />
      )}
    </MainContainer>
  );
};

SmartTableContainer.ModeSwitcher = ModeSwitcher;
SmartTableContainer.EmptyState = EmptyState;

export default SmartTableContainer;
